import { Search } from '../components/quick-order/Search';

class QuickOrder {
    constructor() {
        new Search(); // eslint-disable-line no-new
    }
}

export default QuickOrder;
